/**
 * Returns the message from an unknown thrown value, for a result's `details` field or for logging.
 *
 * Anything that is not an `Error` has no message to read, so it reads as `Unknown error` rather than
 * being stringified. `String(error)` on a plain object gives `[object Object]`, and on a rejected
 * server response it can carry the response body, which is somewhere PHI could turn up.
 */
export const toFailureDetails = (error: unknown): string =>
  error instanceof Error ? error.message : "Unknown error";
